/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { CTAContentfulForHero } from 'bundles/coursera-plus-landing-page/components/ctaContentful/CTAContentful';
import CourseraLiteLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraLiteLogo';
import CourseraPlusLogo from 'bundles/coursera-plus-landing-page/components/heroContentful/CourseraPlusLogo';
import HeroText from 'bundles/coursera-plus-landing-page/components/heroContentful/HeroText';

type LegacyMobileProps = { imageUrl: string; defaultRatio: number; isCourseraLiteContentfulPage: boolean };

// The layout our Yellow Dots and YesICan mobile designs share.

const imgWidth = 282;

const styles = {
  container: () => css`
    text-align: center;
    padding: 24px;
  `,
  image: () => css`
    margin: 26px auto 30px auto;
    width: ${imgWidth}px;
  `,
};

const LegacyMobile = (props: LegacyMobileProps) => {
  const imgHeight = imgWidth * props.defaultRatio;
  return (
    <div css={styles.container}>
      {props.isCourseraLiteContentfulPage ? <CourseraLiteLogo /> : <CourseraPlusLogo />}
      <HeroText />

      <div css={styles.image}>
        <Imgix src={props.imageUrl} maxWidth={imgWidth} maxHeight={imgHeight} alt={Imgix.DECORATIVE} />
      </div>

      <CTAContentfulForHero />
    </div>
  );
};

export default LegacyMobile;
